<template>
	<AddressStaticMap
		:map-img="mapImg"
		:title="title"
		:address="address"
		:lng="lng"
		:lat="lat"
	/>
</template>

<script>
import AddressStaticMap from './AddressStaticMap'

export default {
	name: 'CompanyHangzhouMap',
	components: { AddressStaticMap },
	data() {
		return {
			title: '杭州捷途慧声科技有限公司',
			address:
				'杭州市余杭区数云路2号菜鸟智谷产业园二期B4号楼501、502室',
			lng: 119.974787,
			lat: 30.268718,
			mapImg: require('@/assets/img/company/address/hangzhou-map.png'),
		}
	},
}
</script>
